import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { NeuButton, NeuCard, NeuSelect } from "../../components/neu/Neu";
import { Field } from "../../components/neu/Field";
import { addEmployeeDoc } from "../../api/employeeDocs";
import { DOC_KINDS } from "./docKinds";

export const EmployeeDocForm = ({ userId, onSaved, onCancel }) => {
  const { t } = useTranslation();
  const [form, setForm] = useState({ kind: "national_id", title: "", number: "", expiry: "" });
  const [file, setFile] = useState(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!file) return toast.error(t("empDocs.pickFile"));
    setBusy(true);
    try {
      await addEmployeeDoc(userId, { ...form, file });
      toast.success(t("empDocs.added"));
      onSaved();
    } catch {
      toast.error(t("errors.generic"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <NeuCard className="mt-4 animate-rise-in p-5" data-testid="emp-doc-form">
      <form className="grid gap-4 sm:grid-cols-2" onSubmit={submit}>
        <div>
          <p className="label-xs mb-2">{t("empDocs.kind")}</p>
          <NeuSelect data-testid="emp-doc-kind" value={form.kind} onChange={(e) => setForm({ ...form, kind: e.target.value })}>
            {DOC_KINDS.map((k) => (
              <option key={k} value={k}>
                {t(`empDocs.types.${k}`)}
              </option>
            ))}
          </NeuSelect>
        </div>
        <Field label={t("empDocs.docTitle")} testId="emp-doc-title" value={form.title} onChange={(v) => setForm({ ...form, title: v })} />
        <Field label={t("empDocs.number")} testId="emp-doc-number" value={form.number} onChange={(v) => setForm({ ...form, number: v })} />
        <Field label={t("empDocs.expiry")} testId="emp-doc-expiry" type="date" value={form.expiry} onChange={(v) => setForm({ ...form, expiry: v })} />
        <div className="sm:col-span-2">
          <p className="label-xs mb-2">{t("empDocs.file")}</p>
          <input
            type="file"
            data-testid="emp-doc-file"
            accept="image/*,application/pdf"
            onChange={(e) => setFile(e.target.files?.[0] || null)}
            className="w-full rounded-2xl bg-muted/40 p-3 text-xs"
          />
        </div>
        <div className="flex gap-2 sm:col-span-2">
          <NeuButton variant="primary" type="submit" data-testid="emp-doc-save" disabled={busy}>
            {t("app.save")}
          </NeuButton>
          <NeuButton type="button" data-testid="emp-doc-cancel" onClick={onCancel}>
            {t("app.cancel")}
          </NeuButton>
        </div>
      </form>
    </NeuCard>
  );
};
